// ─────────────────────────────────────────
// supabase.js — your database connection
// ─────────────────────────────────────────
// This file connects your app to Supabase.
// You'll paste YOUR keys here from Supabase dashboard.
// Never share these publicly — keep this file private.

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
